import { signOut } from "firebase/auth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingMask from "../../components/LoadingMask/LoadingMask";
import { auth } from "../../firebase";
import { debugLogError } from "../../utils/debug-log-error";

interface LogoutPageProps {}

const LogoutPage: React.FC<LogoutPageProps> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    signOut(auth)
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        debugLogError("LogoutPage", error);
      });
  }, [navigate]);

  return <LoadingMask message="Logging out..." />;
};

export default LogoutPage;
